/**
 * Hotel search (searchHotels) needs stay dates. Flights-only (planes) never
 * has a hotel checkout — calling the API yields "checkOut cannot be empty"
 * and can spam the console when continuing a 2×OneWay self-compose.
 */

export const PLANES_SEARCH_TAB = "planes";

export function hasHotelStayDates(checkIn, checkOut) {
  return String(checkIn || "").trim() !== "" && String(checkOut || "").trim() !== "";
}

export function shouldRunHotelSearch({ searchTab, checkIn, checkOut } = {}) {
  if (String(searchTab || "").toLowerCase() === PLANES_SEARCH_TAB) return false;
  return hasHotelStayDates(checkIn, checkOut);
}
